/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import SaveMedicalConsent from "./Popup/SaveMedicalConsent";
import { useTranslation } from "react-i18next";

import { MaterialReactTable } from "material-react-table";

//import url and gateway methods
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { commonHeaderLinkLists } from "helper/PatientManagementHelper/PatientManagementHelper";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import ConsentHeader from "./Header/ConsentHeader";
//import MedicalConsentDetails from "./Popup/MedicalConsentDetails";
import PatientViewConsentPopup from "components/ClinicalManagement/Patients/PatientViewConsentPopup";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import { mergeListById, consentOptions } from "helper/Common/CommonHelper";
import MedicalConsentFilter from "./Popup/MedicalConsentFilter";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";


import { vitalsOptions } from "data/medical/vitals";
import { durationOptions } from "data/medical/consentduration"; 

const ConsentListBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [consentList, setConsentList] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedConsentIds, setSelectedConsentIds] = useState([]);
  const [selectedConsentId, setSelectedConsentId] = useState(null);
  const [showViewConsentPopup, setShowViewConsentPopup] = useState(false);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [isDataReady, setIsDataReady] = useState(false);

  //function for get all consent
  const getAllConsent = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_MEDICAL_CONSENTS + `?token=${token}&isowner=true`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in get all consent", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);

      if (response.status) {
        setConsentList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for delete bulk consent
  const deleteBulkConsentHandler = async () => {
    if (selectedConsentIds.length > 0) {
      try {
        const consentListToBeDelete = consentList.filter((item) =>
          selectedConsentIds.includes(item._id)
        );

        let consentData = {
          medicalconsentlist: consentListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_CONSENT +
          `?token=${token}`;

        const response = await putData(requestURL, consentData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setConsentList((prevList) =>
              prevList.filter((item) => !selectedConsentIds.includes(item._id))
            );
            setRowSelection({});
            setSelectedConsentIds([]);
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one consent");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for remove tag from consent
  const removeTagFromConsent = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_MEDICAL_CONSENT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedConsentId(null);
      }, 1000);
    }
  };

  //function for after any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setConsentList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllConsent();
      setIsDataReady(true);
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllConsent();
      setIsDataReady(true);
      setReloadData(false);
      setShowViewConsentPopup(false);
    }
  }, [reloadData]);

  // Helper function to format date
  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#patientViewConsentOffCanvas"
            aria-controls="patientViewConsentOffCanvas"
            onClick={() => {
              setSelectedConsentId(row.original._id);
              setShowViewConsentPopup(true);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Requested By",
        accessorKey: "authorizedusername",
        Cell: ({ row }) => (
          <div
            className={
              row.original.authorizedusername === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.authorizeduserimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.authorizeduserimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.authorizedusername}</span>
            </p>
          </div>
        ),
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 200,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedConsentId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromConsent([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedConsentId &&
                          selectedConsentId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedConsentIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        header: "Authorized Clinic",
        accessorKey: "facilityname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.facilityname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.facilityimage === ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.facilityimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.facilityname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Duration",
        accessorKey: "duration",
        Cell: ({ row }) => {
          const value = row?.original?.duration;
          // Coerce both sides to string so numeric 30 matches option "30"
          const opt = durationOptions.find((o) => String(o.value) === String(value));
          return <span>{opt ? opt.label : (value !== undefined && value !== null ? String(value) : "-")}</span>;
        },
      },
      {
        header: "Approval Status",
        accessorKey: "isapproved",
        Cell: ({ row }) => {
          const approved = !!row?.original?.isapproved;
          const date = row?.original?.approvaldate;
          return approved ? (
            <div className="d-flex align-items-center gap-2">
              <span className="material-symbols-outlined text-success">
                check_circle
              </span>
              <div>
                <div className="fw-medium">Approved</div>
                {date && <small className="text-muted">{formatDateTime(date)}</small>}
              </div>
            </div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <span className="material-symbols-outlined text-warning">
                hourglass_top
              </span>
              <div className="fw-medium">Pending</div>
            </div>
          );
        },
      },
      {
        header: "Consent Elements",
        accessorKey: "consentelements",
        Cell: ({ row }) => {
          const arr = row?.original?.consentelements;
          const count = Array.isArray(arr)
            ? arr.length
            : typeof row?.original?.consentelements_count === "number"
            ? row.original.consentelements_count
            : 0;
          return <span>{count}</span>;
        },
      },
      {
        header: "Created Date",
        accessorKey: "createddate",
      },
    ],
    [selectedConsentId, selectedTagId]
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedConsentIds(selectedIdsArray); // Renamed
    } else {
      setSelectedConsentIds([]); // Renamed
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // memoized selected consent item for the PatientViewConsentPopup
  const selectedConsentItem = useMemo(
    () => consentList.find((c) => c._id === selectedConsentId) || null,
    [consentList, selectedConsentId]
  );

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_PATIENT_MANAGEMENT") &&
      moduleAccess.includes("MOD_CONSENT_MANAGEMENT"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Consent")}
          />
          <div className="container-fluid px-lg-5">
            <ConsentHeader
              reloadList={resetFilterData}
              jsonFilterQuery={jsonFilterQuery}
              selectedItemIds={selectedConsentIds} // Renamed
            />

            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={consentList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}

            <SaveMedicalConsent
              afterActionClose={afterActionClose}
              selectedConsentId={selectedConsentId}
              setSelectedConsentId={setSelectedConsentId}
            />

            {/* <MedicalConsentDetails
              selectedConsentId={selectedConsentId}
              setSelectedConsentId={setSelectedConsentId}
              afterActionClose={afterActionClose}
            /> */}

            {/* Patient view offcanvas showing selected consent request(s) */}
            {/* <PatientViewConsentPopup
              medicalConsentRequests={selectedConsentItem ? [selectedConsentItem] : []}
              onClose={() => setSelectedConsentId(null)}
            /> */}

            <PatientViewConsentPopup
              isOpen={showViewConsentPopup}
              onClose={() => setReloadData(true)}
              selectedConsentId={selectedConsentId}
            />

            <MedicalConsentFilter
              moduleSlug="consentlist"
              setJsonFilterQuery={setJsonFilterQuery}
              isFilterReset={isFilterReset}
              setIsFilterReset={setIsFilterReset}
              reloadList={resetFilterData}
            />

            <AddLabelModal
              moduleName="consent"
              selectedIds={selectedConsentIds} // Renamed
              afterTagModalClose={afterActionClose}
              setShowAlert={setShowAlert}
              setAlertMessage={setAlertMessage}
              setMessageType={setMessageType}
              onModalClose={() => {
                setRowSelection({});
                setSelectedConsentIds([]); // Renamed
              }}
            />

            <DeleteWarningModal
              onDelete={deleteBulkConsentHandler}
              onCancelDelete={() => {
                setRowSelection({});
                setSelectedConsentIds([]); // Renamed
              }}
              moduleName={t("Consent")}
            />

            {showAlert && (
              <AlertNotification
                showAlert={showAlert}
                message={alertMessage}
                alertType={messageType}
                onClose={onAlertClose}
              />
            )}
          </div>
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default ConsentListBody;
